import API from "./API"
import SongContest from "./SongContest"
import { getCookie, setCookie, removeCookie } from "./util"

declare global {
	interface Window { songContest: SongContest, API: API }
}

const YOUTUBE_API_KEY = "AIzaSyBvH-BmtKtmf30EKtiC2rf3XHfhCG_NShI"

const elements = {
	finalTable: document.querySelector("#final") as HTMLTableElement,
	semifinals1Table: document.querySelector("#semifinals1") as HTMLTableElement,
	semifinals2Table: document.querySelector("#semifinals2") as HTMLTableElement,
	loginButton: document.querySelector("#login-button") as HTMLButtonElement,
	logoutButton: document.querySelector("#logout-button") as HTMLButtonElement,
	welcome: document.querySelector("#user .welcome") as HTMLElement,
	username: document.querySelector("#user .username") as HTMLElement,
	loginDialog: document.querySelector("#login-dialog") as HTMLDialogElement,
	loginSubmitButton: document.querySelector("#login-submit-button") as HTMLButtonElement,
	nameInput: document.querySelector("#login-dialog input[name=name]") as HTMLInputElement,
	yearSelect: document.querySelector("#year-select") as HTMLSelectElement,
}

const playlists = await fetch("data/playlists.json").then(data => data.json())
const state = await API.getState(Number(elements.yearSelect.value))
const songContest = new SongContest(elements.finalTable, elements.semifinals1Table, elements.semifinals2Table, state, YOUTUBE_API_KEY, playlists)

window.songContest = songContest
window.API = API

document.documentElement.setAttribute("year", elements.yearSelect.value)

const username = getCookie("user")
if (username) {
	const user = await songContest.login(username)
	if (!user) {
		await API.addUser(username)
		await songContest.login(username)
	}
	elements.logoutButton.classList.remove("hidden")
	elements.loginButton.classList.add("hidden")
	elements.welcome.classList.remove("hidden");
	elements.username.innerText = username
}
songContest.init()

elements.loginButton.onclick = () => elements.loginDialog.showModal()

elements.loginSubmitButton.onclick = async () => {
	setCookie("user", elements.nameInput.value)
	location.reload()
}

elements.logoutButton.onclick = () => {
	removeCookie("user")
	location.reload()
}

elements.yearSelect.onchange = (e) => {
	songContest.setYear(Number((e.target as HTMLSelectElement).value))
	document.documentElement.setAttribute("year", (e.target as HTMLSelectElement).value)
}
